import PropTypes from 'prop-types';
import { cx, css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { isEnabled as isModalEnabled } from '../../../common/utils/modal';
import { getHighlightedButtonClass, singleChoiceOptionClass } from '../../../common/utils/styles';
import ToggleBarContainer from '../../../single-choice/containers/ToggleBarContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const formatGet = value => value ? value.value : null;
const formatSet = priceRaw => value => ({
  priceRaw,
  value
});
const getOption = (productName, selected, label, value, isNeutral) => ({
  className: cx(singleChoiceOptionClass, !isNeutral && getHighlightedButtonClass(selected, value)),
  dataTestId: `${productName}--${value}`,
  id: `${productName}_${value}`,
  label,
  value
});
const wrapperStyles = css`
  grid-column: 1 / 3;
`;
const ManulifeToggleBar = _ref => {
  let {
    className,
    form,
    isNeutral,
    persuasion,
    confirmation,
    confirmationModalName,
    priceRaw,
    productName,
    setPersuasionIsOpen,
    setPersuasionOnConfirm,
    setPersuasionOnDecline,
    isSelected
  } = _ref;
  const {
    t
  } = useTranslation();
  const options = [getOption(productName, isSelected, t('Product.SingleChoice.Label.No'), false, isNeutral), getOption(productName, isSelected, t('Product.SingleChoice.Label.Yes'), true, isNeutral)];
  return /*#__PURE__*/_jsx(ToggleBarContainer, {
    className: cx(className, wrapperStyles),
    confirmationModalName: confirmationModalName,
    form: form,
    formatGet: formatGet,
    formatSet: formatSet(priceRaw),
    inputName: productName,
    isConfirmationEnabled: isModalEnabled(confirmation),
    isNeutral: isNeutral,
    legend: t('Product.SelectOne.Label'),
    name: "value",
    options: options,
    persuasionEnabled: isModalEnabled(persuasion),
    priceRaw: priceRaw,
    setPersuasionIsOpen: setPersuasionIsOpen,
    setPersuasionOnConfirm: setPersuasionOnConfirm,
    setPersuasionOnDecline: setPersuasionOnDecline,
    size: "large",
    validationRuleName: productName
  });
};
ManulifeToggleBar.propTypes = {
  className: PropTypes.string,
  confirmation: PropTypes.shape({
    buttonType: PropTypes.string
  }),
  confirmationModalName: PropTypes.string,
  form: PropTypes.string,
  isNeutral: PropTypes.bool,
  isSelected: PropTypes.bool,
  persuasion: PropTypes.shape({
    buttonType: PropTypes.string
  }),
  priceRaw: PropTypes.number,
  productName: PropTypes.string,
  setPersuasionIsOpen: PropTypes.func,
  setPersuasionOnConfirm: PropTypes.func,
  setPersuasionOnDecline: PropTypes.func
};
export default ManulifeToggleBar;